import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;
// The live app answers on several hosts (custom domain, emergent.host); call the host the page is on to avoid cross-site blocks.
const BASE = ENV_URL && new URL(ENV_URL).host !== window.location.host ? window.location.origin : ENV_URL;

export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return fallback;
};
